type Score = number | undefined
type KodemScoreSeverity = "critical" | "high" | "medium" | "low" | "unknown"

export const getScore = (score: Score, fractionDigits = 1) => {
  return score?.toFixed(fractionDigits) ?? "N/A"
}

export const getPostureScoreSeverity = (score: number) => {
  if (!score || score < 70) {
    return {
      result: "unsatisfactory"
    }
  }
  if (score < 80) {
    return {
      result: "fair"
    }
  }
  if (score < 85) {
    return {
      result: "solid"
    }
  }
  if (score < 90) {
    return {
      result: "good"
    }
  }

  if (score < 95) {
    return {
      result: "excellent"
    }
  }

  return {
    result: "exceptional"
  }
}

export const KODEM_SCORE_THRESHOLDS_BY_SEVERITY = [9, 7, 4, 0]
const KODEM_SCORE_THRESHOLDS_BY_SCORE = [899, 699, 399, 0]
const KODEM_SCORE_SEVERITIES: KodemScoreSeverity[] = [
  "critical",
  "high",
  "medium",
  "low",
  "unknown"
]

export const getKodemScoreSeverity = (score: Score, thresholds: number[]) => {
  if (!score || score < 0) return "unknown"

  const index = thresholds.findIndex((threshold) => score >= threshold)

  return KODEM_SCORE_SEVERITIES[index]
}

export const getKodemScoreColorBySeverity = (score: Score) => {
  return `var(--${getKodemScoreSeverity(score, KODEM_SCORE_THRESHOLDS_BY_SEVERITY)}-ks)`
}

export const getKodemScoreColorByScore = (score: Score) => {
  return `var(--${getKodemScoreSeverity(score, KODEM_SCORE_THRESHOLDS_BY_SCORE)}-ks)`
}
